import React from 'react';
import PropTypes from 'prop-types';

import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';



class MultipleGroupeSelect extends React.Component {


    handleChange = event => {

        const { onChange, selected } = this.props;
        

        if (selected.length === 0) {
            event.target.value = event.target.value.filter(x => x !== -1);
        }
        else {
            if (event.target.value.indexOf(-1) > -1) {
                event.target.value = [];
            }
        }
        

        onChange(event);
    };


    render() {
        const { selected, groupes, size } = this.props;

        let computedSelection = selected.filter(x => x !== -1);

        let renderValue = "Tous";
        if (computedSelection.length === 0) {
            computedSelection = [-1];
        }
        else {
            var groupe = groupes.find(x => x.id === computedSelection[0]);
            renderValue = groupe.libelle;

            if (computedSelection.length > 1) {
                renderValue += ' +' + (computedSelection.length - 1);
            }
        }


        return (

            <TextField
                id={"groupesEmetteur"}
                name={"groupesEmetteur"}
                label={"Groupe de l'émetteur"}
                fullWidth
                size={size}
                select
                SelectProps={{
                    multiple: true,
                    value: computedSelection,
                    onChange: this.handleChange,
                    renderValue: () => {
                        return (<div>{renderValue}</div>);
                    }
                }}
            >

                
                    <MenuItem key={-1} value={-1}>

                        <Radio checked={computedSelection.indexOf(-1) >= 0} />
                        <ListItemText primary="Tous" />
                    </MenuItem>

                    <ListSubheader>Sélectionner un ou plusieurs groupes</ListSubheader>

                    {groupes.map((groupe, index) => (
                        <MenuItem key={index} value={groupe.id}>

                            <Checkbox checked={computedSelection.indexOf(groupe.id) >= 0} />
                            <ListItemText primary={groupe.libelle} />
                        </MenuItem>
                    ))}


            </TextField>

        );
    }
}

MultipleGroupeSelect.propTypes = {
    selected: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,

    groupes: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    size: PropTypes.string

};

export default MultipleGroupeSelect;